import { render, staticRenderFns } from "./DeputyCreateDialog.vue?vue&type=template&id=7f029f2c&scoped=true"
import script from "./DeputyCreateDialog.vue?vue&type=script&lang=js"
export * from "./DeputyCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f029f2c",
  null
  
)

export default component.exports